// Static wardrobe pricing removed — pricing comes from WooCommerce product meta.

export const wardrobeTextureGroups = {};
export const designPricing = {};
